import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const fetchMeta = async () => (await axios.get(`${API}/meta`)).data;

export const fetchProducts = async (params = {}) => {
  const clean = Object.fromEntries(Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ""));
  return (await axios.get(`${API}/products`, { params: clean })).data;
};

export const fetchProduct = async (slug) => (await axios.get(`${API}/products/${slug}`)).data;

export const createEnquiry = async (payload) => (await axios.post(`${API}/enquiries`, payload)).data;

export const requestCatalogue = async (payload) => (await axios.post(`${API}/catalogue-requests`, payload)).data;
